import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {Grid, makeStyles} from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import styles from "../../../assets/jss/material-dashboard-react/views/modalStyle";
import Button from "../../components/CustomButtons/Button"
import RepaymentDetails from "./RepaymentDetails";
import AddressDetails from "./AddressDetails";
import ReferenceReview from "./ReferenceDetails";
import LoanDetailsReview from "./LoanDetails";
import IncomeDetailsReview from "./IncomeDetails";
import PersonalInfoReview from "./PersonalInfoReview";
import BankDetails from "./BankDetails";
import MandateDetails from "./MandateDetails";
import DocumentReview from "./DocumentReview";
const useStyles = makeStyles((theme) => ({
  container: {
    height: "100vh", // Full window height
    overflowY: "auto", // Enable vertical scrolling
    padding: theme.spacing(2),
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    width:"92%",
    margin:"0 auto"
  },
  content: {
    flex: 1,
    overflowY: "auto",
    padding: theme.spacing(2),
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
}));

const CompleteLoanDetailsReview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  // Retrieve loanNumber from state
  const leadId = location.state?.id;
  const [callInProgress, setCallInProgress] = useState(false);
  const [incomeDetails, setIncomeDetails] = useState({});
  const [generalDetails, setGeneralDetails] = useState({});
  const [referenceDetails, setReferenceDetails] = useState({});
  const [loanDetails, setLoanDetails] = useState({});
  const [documentDetails, setDocumentDetails] = useState({});
  const [repaymentDetails, setRepaymentDetails] = useState({});
  const [userLeadIdDetails, setUserLeadIdDetails] = useState({});
  const [addressDetails, setAddressDetails] = useState({});
  const [bankDetails, setBankDetails] = useState({});
  const [adhaarDetails, setAdhaarDetails] = useState({});
  const [photoDetails, setPhtotDetails] = useState({});
  const [mandateDetails, setMandateDetails] = useState({});
  const [eligibleAmountDetails, setEligibleAmountDetails] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  console.log(leadId,"flaljdfkjadjk")
  useEffect(() => {
    if (leadId) {
      fetchLoanSummary();
    }
  }, [leadId]);

  const fetchLoanSummary = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_ALL_LEAD_DETAILS + leadId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setIncomeDetails(result?.data?.incomeDetail);
      setGeneralDetails(result?.data?.applicantDetail);
      setReferenceDetails(result?.data?.leadRefferal);
      setLoanDetails(result?.data?.leadLoanDetail);
      setDocumentDetails(result?.data?.leadDocumentDetail);
      setRepaymentDetails(result?.data?.leadReaymentDetail);
      setUserLeadIdDetails(result?.data?.leadApplication);
      setAddressDetails(result?.data?.applicantAddress);
      setBankDetails(result?.data?.applicantBankDetail);
      setAdhaarDetails(result?.data?.aadharDetails);
      setPhtotDetails(result?.data?.photoDetails);
      setMandateDetails(result?.data?.mandateDetails);
      setEligibleAmountDetails(
        result?.data?.leadApplication?.max_eligible_loan_amount
      );
    }
  };
  return (
    <Grid container className={classes.container}>
    <Grid item xs={12}>
      <SubHeader label="REVIEW SCREEN" />
    </Grid>
    <Grid container className={classes.content}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {generalDetails && (
          <>
            <PersonalInfoReview
              classes={classes}
              documentDetails={documentDetails}
              generalDetails={generalDetails}
              userLeadIdDetails={userLeadIdDetails}
              photoDetails={photoDetails}
            />
            <hr />
          </>
        )}
        {incomeDetails && (
          <>
            <IncomeDetailsReview
              classes={classes}
              incomeDetails={incomeDetails}
              userLeadIdDetails={userLeadIdDetails}
              adhaarDetails={adhaarDetails}
            />
            <hr />
          </>
        )}
        {loanDetails && (
          <>
            <LoanDetailsReview
              classes={classes}
              loanDetails={loanDetails}
              eligibleAmountDetails={eligibleAmountDetails}
            />
            <hr />
          </>
        )}
        {repaymentDetails && (
          <>
            <RepaymentDetails
              classes={classes}
              repaymentDetails={repaymentDetails}
            />
            <hr />
          </>
        )}
        {referenceDetails && referenceDetails?.length > 0 && (
          <>
            <ReferenceReview
              classes={classes}
              referenceDetails={referenceDetails}
            />
            <hr />
          </>
        )}
        {addressDetails && addressDetails?.length > 0 && (
          <>
            <AddressDetails
              classes={classes}
              addressDetails={addressDetails}
            />
            <hr />
          </>
        )}
        {bankDetails && (
          <>
            <BankDetails classes={classes} bankDetails={bankDetails}/>
            <hr />
          </>
        )}
        {documentDetails?.sanctionletter && (
          <>
            <DocumentReview
              classes={classes}
              documentDetails={documentDetails}
            />
            <hr />
          </>
        )}
        {mandateDetails?.mandateId && (
          <>
            <MandateDetails
              classes={classes}
              mandateDetails={mandateDetails}
            />
            <hr />
          </>
        )}
      </Grid>
    </Grid>
      <Grid container className={classes.footer}>
        <Button size="small">Cancel</Button>
      </Grid>
    {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
  </Grid>
  );
};

export default CompleteLoanDetailsReview;